import { Masters } from "../../../atoms/masters.atom";
import { desluggify } from "../string/desluggify";

const memoizedStore: Record<
  string,
  Record<string | number, string | number>
> = {};

export const valueToLabel = (
  key: string,
  value: number | string | undefined,
  masters: Masters,
  desluggifyValue = false
) => {
  if (value === undefined) return null;

  if (key in memoizedStore && value in memoizedStore[key])
    return memoizedStore[key][value];

  const label =
    masters[key]?.find(({ key }) => key === value)?.value ??
    (desluggifyValue ? desluggify(String(value), "_") : value);

  if (!(key in memoizedStore)) memoizedStore[key] = {};
  memoizedStore[key][value] = label;

  return label;
};
